import { render } from "./evaPeopleNumEchart.vue?vue&type=template&id=d00239b4&scoped=true"
import script from "./evaPeopleNumEchart.vue?vue&type=script&lang=js"
export * from "./evaPeopleNumEchart.vue?vue&type=script&lang=js"

import "./evaPeopleNumEchart.vue?vue&type=style&index=0&id=d00239b4&scoped=true&lang=scss"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d00239b4"]])

export default __exports__